module.exports = __webpack_public_path__ + "68d1d92508852ce3b5d754ac00b43732.jpg";